import api from "@/shared/services/api";
import {
  getEmptyPaymentInstallmentIndicators,
  PaymentInstallmentIndicators,
  PaymentInstallmentListParams,
  PaymentInstallmentListResult,
  PaymentInstallmentRow,
} from "../types/paymentInstallments.types";

const mapPaymentInstallmentRow = (row: any): PaymentInstallmentRow => ({
  id: row.id,
  operationId: row.operationId,
  clientId: row.clientId,
  paidAt: row.paidAt ?? null,
  date: row.date,
  amountUsd: row.amountUsd ?? 0,
  clientName: row.clientName ?? "",
  status: row.status ?? "",
  statusName: row.statusName ?? "",
});

const normalizeIndicators = (value: any): PaymentInstallmentIndicators => {
  const empty = getEmptyPaymentInstallmentIndicators();
  const data = value || {};

  return {
    total: data.total || empty.total,
    paid: data.paid || empty.paid,
    pending: data.pending || empty.pending,
    overdue: data.overdue || empty.overdue,
    inArrears: data.inArrears || empty.inArrears,
  };
};

type PaymentInstallmentsServiceEndpoints = {
  list: string;
  statistics: string;
};

const defaultEndpoints: PaymentInstallmentsServiceEndpoints = {
  list: "/operation/all-payments",
  statistics: "/operation/payment-statistics",
};

const createPaymentInstallmentsService = (endpoints = defaultEndpoints) => ({
  async getPaymentInstallments(
    params: PaymentInstallmentListParams,
  ): Promise<PaymentInstallmentListResult> {
    const response = await api.get(endpoints.list, { params });
    const data = Array.isArray(response.data?.data) ? response.data.data : [];

    return {
      data: data.map(mapPaymentInstallmentRow),
      totalCount: response.data?.totalCount ?? 0,
    };
  },

  async getStatistics(
    params: PaymentInstallmentListParams = {},
  ): Promise<PaymentInstallmentIndicators> {
    const response = await api.get(endpoints.statistics, {
      params,
    });
    return normalizeIndicators(response.data?.data || response.data || {});
  },
});

const paymentInstallmentsService = createPaymentInstallmentsService();

export const creditLinePaymentInstallmentsService =
  createPaymentInstallmentsService({
    list: "/credit-line/operation/all-payments",
    statistics: "/credit-line/operation/payment-statistics",
  });

export type PaymentInstallmentsService = typeof paymentInstallmentsService;

export default paymentInstallmentsService;
